import { useNavigate } from "react-router-dom";
import Modal from "../../../../components/portal/Modal";
import successIcon from "../../../../assets/icons/successIcon.svg";
import GradientButton from "../../../../components/UI/buttonUI/GradientButton";

const UpdateBulkSiteSuccess = ({ viewDetails }) => {
  const navigate = useNavigate();
  return (
    <Modal modalWidth="view-dialog-content max-w-4xl">
      <img src={successIcon} alt="messageIcon" className="mx-auto mb-1 w-9" />
      <p className="view-success-msg-d">Sheet Successfully Updated!</p>
      <div className="rounded-md 3xl border border-lg5 shadow-md mt-4 relative p-3">
        <div className="overflow-y-auto max-h-[400px] border-1 border-lg5 border-t-0">
          <table className={`w-full text-center border-collapse`}>
            <thead
              className={`text-white font-poppins text-sm font-extralight bg-dark-blue sticky top-0`}
            >
              <th className="border border-lg5">Site Id</th>
              <th className="border border-lg5">Site Name</th>
              <th className="border border-lg5">JE</th>
              <th className="border border-lg5">JBCC FT</th>
              <th className="border border-lg5">JN FT</th>
              <th className="border border-lg5">Category Name</th>
              <th className="border border-lg5">Machine Id</th>
            </thead>
            <tbody className="font-figtree 2xs:max-sm:text-xs">
              {viewDetails.map((item, ind) => {
                return (
                  <tr key={ind} className="text-sm odd:bg-white even:bg-lg6">
                    <td className="border border-lg5">{item.id}</td>
                    <td className="border border-lg5">{item.name}</td>
                    <td className="border border-lg5">{item.je.name}</td>
                    <td className="border border-lg5">
                      {item.jbccFieldTechnician.fullName}
                    </td>
                    <td className="border border-lg5">
                      {item.jnFieldTechnician.fullName}
                    </td>
                    <td className="border border-lg5">{item.category.name}</td>
                    <td className="border border-lg5">{item.machineID}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <table className="w-full mt-2">
          <tbody>
            <tr className="bg-lg6">
              <td className="p-2 border border-lg5 text-dark-blue font-figtreeMedium text-sm">
                Total Site Updated : {viewDetails.length}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="md:mt-5 pt-3 text-center">
        <GradientButton
          btnText="Ok"
          width="28"
          onClick={() => navigate("/site/all")}
        />
      </div>
    </Modal>
  );
};

export default UpdateBulkSiteSuccess;
